import React, { useState, useEffect } from "react";
import axios from "axios";
import "./EditUserModal.css";

export default function EditUserModal({ show, user, onClose, onSaved }) {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (user) {
      setEmail(user.email);
      setFirstName(user.firstName);
      setLastName(user.lastName);
    }
  }, [user]);

  if (!show || !user) return null;

  const handleSave = async () => {
    if (!email || !firstName || !lastName) {
      setError("Todos os campos são obrigatórios.");
      return;
    }
    try {
      await axios.put(
        `${import.meta.env.VITE_BACKEND_URL}/users/${user.username}`,
        { email, firstName, lastName },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      onSaved(); 
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || "Erro ao salvar.");
    }
  };

  return (
    <div className="modal-overlay edit-user-modal">
      <div className="modal-content">
        <h3>Editar Usuário</h3>
        {error && <div className="error-text">{error}</div>}

        <label>E‑mail</label>
        <input value={email} onChange={e => setEmail(e.target.value)} />

        <label>Nome</label>
        <input value={firstName} onChange={e => setFirstName(e.target.value)} />

        <label>Sobrenome</label>
        <input value={lastName} onChange={e => setLastName(e.target.value)} />

        <div className="modal-buttons">
          <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button className="btn btn-primary" onClick={handleSave}>Salvar</button>
        </div>
      </div>
    </div>
  );
}
